import React from 'react';
import { adminUser_listAdmins_data, updateUserVariables } from '@api/graphql/types';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import { compose } from 'react-apollo';
import * as Mutations from '@api/graphql/mutations';
import GraphQLClient from '@api/graphql/GraphQLClient';
import Paths from '@root/utils/Path';
import Form from '@components/Form/Form';

interface Props {
    user: adminUser_listAdmins_data;
}

interface State {
    formData: updateUserVariables;
}

type PropType = Props & InjectedIntlProps;

class EditForm extends React.Component<PropType, State> {
    public constructor(props: PropType) {
        super(props);
        const { id, name, email, telephone } = props.user;
        this.state = {
            formData: {
                id,
                name,
                email,
                telephone,
            },
        };
    }

    private onSubmit = (formData: updateUserVariables) => {
        const variables = {...formData};
        if (!variables.telephone) {
            variables.telephone = '';
        }
        return GraphQLClient.mutate({
            mutation: Mutations.updateUser,
            variables,
        });
    }

    private validate = () => {
        return true;
    }

    public render() {
        const fields = [
            {name: 'name', type: 'text'},
            {name: 'email', type: 'text'},
            {name: 'telephone', type: 'text'},
        ];

        return (
            <Form
                intlPrefix='module.adminUser'
                fields={[{id: 'default', fields}]}
                formData={this.state.formData}
                onSubmit={this.onSubmit}
                validate={this.validate}
                redirectPath={Paths.adminUser}
            />
        );
    }
}

export default compose(
    injectIntl,
)(EditForm);



// WEBPACK FOOTER //
// ./src/modules/AdminUser/components/EditForm.tsx